const API_URL = 'https://loyaltylion-dot-vitamoment.ey.r.appspot.com/api';
/**
 * Reorder
 */
(function () {
    const reorderPopovers = document.querySelectorAll('.ReorderPopover');
    reorderPopovers.forEach((popover) => {
        const addButton = popover.querySelector('.Reorder__AddButton');
        if (addButton) {
            addButton.addEventListener('click', (e) => {
                const target = e.target;
                const items = JSON.parse(target.getAttribute('data-items')).items;
                window.waitForFunction("addToCart", [items]);
            });
        }
    });
})();
/**
 * Account panel visibility
 */
(function () {
    const sectionButtons = document.querySelectorAll('.AccountNavigation__Item[data-section-nav]'), sections = document.querySelectorAll('[data-account-section]'), formatSectionName = (sectionName, forUrl = false) => {
        if (forUrl) {
            return sectionName.replaceAll(' ', '_');
        }
        else {
            return sectionName.replaceAll('_', ' ');
        }
    };
    if (sectionButtons.length === 0 || sections.length === 0) {
        return;
    }
    // Listeners on nav buttons to trigger selection change
    sectionButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            const target = e.target;
            document.dispatchEvent(new CustomEvent('account:item:changed', { detail: target.getAttribute('data-section-nav') }));
        });
    });
    // Listeners on collapsible buttons to trigger selection change
    sections.forEach((section) => {
        const collapsibleButton = section.querySelector('.Collapsible__Button');
        if (!collapsibleButton)
            return;
        collapsibleButton.addEventListener('click', (e) => {
            const target = e.target;
            document.dispatchEvent(new CustomEvent('account:item:changed', { detail: target.closest('[data-account-section]').getAttribute('data-account-section') }));
        });
    });
    // Handle changes of the selected account item
    document.addEventListener('account:item:changed', (e) => {
        const customEvent = e;
        const sectionName = customEvent.detail;
        // Handle section visibility
        sections.forEach((section) => {
            const collapsibleButton = section.querySelector('.Collapsible__Button');
            if (window.handleize(section.getAttribute('data-account-section')) === window.handleize(sectionName)) {
                section.classList.remove('md:none');
                section.classList.add('md:block');
                // Open collapsible (mobile) for non-mobile screens
                if (window.matchMedia('screen and (min-width: 768px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'false') {
                    const inner = section.querySelector('.Collapsible__Inner');
                    collapsibleButton.setAttribute('aria-expanded', 'true');
                    inner.style.overflow = 'visible';
                    inner.style.height = 'auto';
                    section.style.overflow = 'visible';
                }
            }
            else {
                section.classList.remove('md:block');
                section.classList.add('md:none');
                // Close inactive collapsible (mobile) for non-mobile screens
                if (window.matchMedia('screen and (min-width: 768px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'true') {
                    collapsibleButton.setAttribute('aria-expanded', 'false');
                    resetCollapsibleStyles(section);
                }
            }
        });
        // Set current section button active
        sectionButtons.forEach((button) => {
            if (button.getAttribute('data-section-nav') === sectionName) {
                button.classList.add('is-active');
            }
            else {
                button.classList.remove('is-active');
            }
        });
        // Set url hash
        history.replaceState(null, '', '#' + formatSectionName(sectionName, true));
    });
    // Reset styles set through Collapsible functionality to make panel visibility work after screen width increases from mobile view
    const resetCollapsibleStyles = function (collapsible) {
        const inner = collapsible.querySelector('.Collapsible__Inner');
        collapsible.style.overflow = '';
        inner.style.overflow = '';
        inner.style.height = '';
    };
    sections.forEach((section) => {
        section.addEventListener('collapsible:closed', (e) => {
            resetCollapsibleStyles(e.target);
        });
    });
    // Check hash on initial page load
    const handleInitialHash = function () {
        if (window.themeJSReady) {
            const hash = window.location.hash.replace('#', '').split('?')[0], sectionName = formatSectionName(decodeURI(hash)), sectionButton = document.querySelector(`.AccountNavigation__Item[data-section-nav="${sectionName}"]`), collapsibleButton = document.querySelector(`[data-account-section="${sectionName}"] .Collapsible__Button`);
            if (sectionButton && !sectionButton.classList.contains('is-active')) {
                sectionButton.click();
            }
            if (collapsibleButton && window.matchMedia('screen and (max-width: 767px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'false') {
                window.scrollTo({
                    behavior: 'smooth',
                    top: collapsibleButton.offsetTop
                });
                collapsibleButton.click();
            }
        }
        else {
            setTimeout(handleInitialHash, 100);
        }
    };
    handleInitialHash();
})();
function waitForLoyaltyLionCustomer(callback, timeout = 5000) {
    const start = Date.now();
    const interval = setInterval(() => {
        if (window.loyaltylion?.customer) {
            clearInterval(interval);
            callback(window.loyaltylion.customer);
        }
        if (Date.now() - start > timeout) {
            clearInterval(interval);
        }
    }, 100);
}
waitForLoyaltyLionCustomer(initVouchers);
async function initVouchers() {
    let vouchers = [];
    try {
        const res = await fetch(`${API_URL}/vouchers`);
        vouchers = await res.json();
    }
    catch (e) {
        console.log(e);
    }
    if (!vouchers.length)
        return;
    const sliderContainer = document.getElementById('voucher-slider');
    if (!sliderContainer)
        return;
    const viewport = sliderContainer.querySelector('.Slider__Viewport');
    const content = sliderContainer.querySelector('.Slider__Content');
    if (!viewport || !content)
        return;
    const template = sliderContainer.querySelector('[data-copy-voucher]');
    let templateHTML = "";
    if (template) {
        templateHTML = template.outerHTML;
        template.remove();
    }
    vouchers.forEach(voucher => {
        const slide = document.createElement('div');
        slide.className = 'Slider__Slide Carousel__Cell';
        slide.innerHTML = templateHTML;
        const card = slide.querySelector('[data-copy-voucher]');
        if (!card)
            return;
        const nameEl = card.querySelector('[data-name]');
        if (nameEl) {
            nameEl.textContent = voucher.name;
        }
        const costsEl = card.querySelector('[data-costs]');
        if (costsEl) {
            costsEl.textContent = `${voucher.costs}`;
        }
        const clubEl = card.querySelector('[data-club-progress-price]');
        if (clubEl) {
            clubEl.setAttribute('data-club-progress-price', String(voucher.costs));
        }
        const button = card.querySelector('.RedeemButton');
        if (button) {
            button.dataset.id = String(voucher.id);
            button.dataset.title = voucher.name;
            button.dataset.costs = String(voucher.costs);
        }
        content.appendChild(slide);
    });
    const slider = new Slider(sliderContainer);
    slider.enable();
    loadRedeemedProducts().then();
    document.dispatchEvent(new CustomEvent('theme:product_carousel:loaded', { detail: sliderContainer }));
    //@ts-expect-error
    const domDelegateInstance = new domDelegate.Delegate(document.body);
    domDelegateInstance.on('click', '[data-action="open-redeem-dialog"]', (e) => {
        const modalId = 'redeem-dialog';
        const dialog = document.querySelector(`#${modalId}`);
        if (!dialog)
            return;
        dialog.querySelector('[data-page="get"]')?.classList.remove('none');
        dialog.querySelector('[data-page="use"]')?.classList.add('none');
        const trigger = e.target;
        dialog.dataset.id = trigger.dataset.id;
        dialog.querySelector('#redeem-dialog-title').innerHTML = trigger.dataset.title;
        dialog.querySelector('.redeemPoints').innerHTML = trigger.dataset.costs;
        let modal = window.Modal.modals[modalId];
        if (!modal) {
            modal = new window.Modal(document.getElementById(modalId));
        }
        modal.open();
    });
    domDelegateInstance.on('click', '[data-copy-button]', async (e) => {
        const button = e.target.closest('[data-copy-button]');
        if (!button)
            return;
        const container = button.parentElement;
        const codeEl = container?.querySelector('[data-code]');
        if (!codeEl)
            return;
        const text = codeEl.textContent.trim();
        const svgs = button.querySelectorAll('svg');
        const copyIcon = svgs[0];
        const successIcon = svgs[1];
        if (!copyIcon || !successIcon)
            return;
        try {
            await navigator.clipboard.writeText(text);
            copyIcon.classList.add('hidden');
            successIcon.classList.remove('hidden');
            codeEl.classList.add('bg-background-primary');
            setTimeout(() => {
                successIcon.classList.add('hidden');
                copyIcon.classList.remove('hidden');
                codeEl.classList.remove('bg-background-primary');
            }, 1200);
        }
        catch (err) {
            console.error('Copy failed', err);
        }
    });
    domDelegateInstance.on('click', '[data-action="voucher-to-checkout"]', async (e) => {
        const trigger = e.target;
        trigger.classList.add('loading');
        const modalId = 'redeem-dialog';
        const dialog = document.querySelector(`#${modalId}`);
        if (!dialog)
            return;
        const codeEl = dialog.querySelector('[data-code]');
        if (!codeEl)
            return;
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codeEl.textContent.trim() })
        });
        await window.Cart.rerenderDrawerCart();
        let modal = window.Modal.modals[modalId];
        modal?.close();
        window.Cart.open();
        trigger.classList.remove('loading');
    });
    domDelegateInstance.on('click', '[data-action="open-redeemed-product"]', async (e) => {
        const trigger = e.target;
        const modalId = 'redeemed-product';
        const { title, costs, code, expiresAt, activatedAt } = trigger.dataset;
        const expireDate = new Date(expiresAt);
        const dialog = document.querySelector(`#${modalId}`);
        if (!dialog)
            return;
        dialog.querySelector('#redeemed-product-title').innerHTML = title;
        dialog.querySelector('[data-code]').innerHTML = code;
        dialog.querySelector('[data-costs]').innerHTML = costs;
        dialog.querySelector('[data-activated-at]').innerHTML = activatedAt;
        dialog.querySelector('[data-expire-date]').innerHTML = expireDate.toLocaleDateString().replaceAll('/', '.');
        let modal = window.Modal.modals[modalId];
        if (!modal) {
            modal = new window.Modal(document.getElementById(modalId));
        }
        modal.open();
    });
    domDelegateInstance.on('click', '[data-action="redeem-voucher"]', async (e) => {
        const trigger = e.target;
        trigger.classList.add('loading');
        const dialog = trigger.closest('#redeem-dialog');
        const rewardId = +dialog.dataset.id;
        const { email, merchantId: gId } = window.loyaltylion.customer;
        try {
            const res = await fetch(`${API_URL}/redeem`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    rewardId,
                    gId
                })
            });
            const data = await res.json();
            loadRedeemedProducts().then();
            dialog.querySelector('[data-page="get"]')?.classList.add('none');
            dialog.querySelector('[data-page="use"]')?.classList.remove('none');
            const approvedPointsEl = document.querySelector('[data-lion-points="approved"]');
            const redeemPointsEl = document.querySelector('.redeemPoints');
            if (approvedPointsEl && redeemPointsEl) {
                const approved = parsePoints(approvedPointsEl.innerText);
                const redeem = parsePoints(redeemPointsEl.innerText);
                const newApprovedPointsEl = document.createElement('span');
                newApprovedPointsEl.setAttribute('data-lion-points', 'approved');
                newApprovedPointsEl.innerText = formatPoints(approved - redeem);
                approvedPointsEl.replaceWith(newApprovedPointsEl);
            }
            dialog.querySelector('[data-code]').innerHTML = data.voucher_code;
            const expireDate = new Date(data.expires_at);
            dialog.querySelector('[data-expire-date]').innerHTML = expireDate.toLocaleDateString().replaceAll('/', '.');
        }
        catch (e) {
            console.log(e);
        }
        trigger.classList.remove('loading');
    });
}
async function loadRedeemedProducts() {
    const table = document.body.querySelector('[data-redeem-table]');
    const templateEl = document.querySelector('[data-redeemed-template]');
    let templateHTML = '';
    if (templateEl) {
        templateHTML = templateEl.outerHTML;
        templateEl.remove();
    }
    let redeemedElements = [];
    if (!table)
        return;
    try {
        const { email, merchantId } = window.loyaltylion.customer;
        const res = await fetch(`${API_URL}/rewards/${merchantId}?email=${email}`);
        redeemedElements = await res.json();
    }
    catch (e) {
        console.error(e);
    }
    if (!redeemedElements.length)
        return;
    table.innerHTML = '';
    redeemedElements.forEach(({ title, claimed_at, used_at, costs, code, expires_at }) => {
        const relativeText = getRelativeDayText(claimed_at);
        const wrapper = document.createElement('div');
        wrapper.innerHTML = templateHTML;
        const row = wrapper.firstElementChild;
        if (!row)
            return;
        row.querySelector('[data-title]').textContent = title;
        row.querySelector('[data-relative-time]').textContent = relativeText;
        const button = row.querySelector('button');
        button.dataset.title = title;
        button.dataset.costs = String(costs);
        button.dataset.code = code;
        button.dataset.expiresAt = expires_at ?? '';
        button.dataset.activatedAt = relativeText;
        const textUsed = window.languages.club.vouchers.redeemed.used;
        const textView = window.languages.club.vouchers.redeemed.viewCode;
        if (!used_at) {
            button.textContent = textView;
        }
        else {
            button.disabled = true;
            button.textContent = `${relativeText} ${textUsed}`;
        }
        row.classList.remove('hidden');
        table.appendChild(row);
    });
}
function getRelativeDayText(claimedAt) {
    const claimed = new Date(claimedAt);
    const now = new Date();
    const claimedLocal = new Date(claimed.getFullYear(), claimed.getMonth(), claimed.getDate());
    const todayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.round((todayLocal.getTime() - claimedLocal.getTime()) /
        (1000 * 60 * 60 * 24));
    if (diffInDays === 0)
        return window.languages.club.vouchers.redeemed.today;
    if (diffInDays === 1)
        return window.languages.club.vouchers.redeemed.yesterday;
    return (window.languages.club.vouchers.redeemed.days).replace('__DAYS__', String(diffInDays));
}
function parsePoints(value) {
    return parseInt(value.replace(/\./g, ''), 10);
}
function formatPoints(value) {
    return value.toLocaleString('de-DE');
}
/**
 * Diagnostic tests
 */
(function () {
    const activationModalId = 'modal-lab-test-activation', activationForm = document.querySelector(`#${activationModalId} form`);
    if (!activationForm)
        return;
    class API {
        static async verify(testId, customerId) {
            return new Promise((resolve, reject) => {
                fetch(`${this.URL}/verify`, {
                    method: 'POST',
                    body: JSON.stringify({
                        testCode: testId,
                        customerCode: customerId
                    }),
                    headers: {
                        'X-Vm-Token': window.theme.customerToken || '',
                        'X-Vm-Id': window.theme.customerId || '',
                        'Content-Type': 'application/json'
                    }
                }).then(response => {
                    if (response.status !== 200)
                        throw `[Error] Verify: API returned ${response.status}`;
                    return response.json();
                }).then(data => {
                    resolve(data.available);
                }).catch(err => {
                    reject(err);
                });
            });
        }
        static async activate(data) {
            return new Promise((resolve, reject) => {
                fetch(`${this.URL}/activate`, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'X-Vm-Token': window.theme.customerToken || '',
                        'X-Vm-Id': window.theme.customerId || '',
                        'Content-Type': 'application/json'
                    }
                }).then(response => {
                    if (response.status !== 200)
                        throw `[Error] Activate: API returned ${response.status}`;
                    return response.json();
                }).then(data => {
                    resolve(data.success);
                }).catch(err => {
                    reject(err);
                });
            });
        }
    }
    API.URL = 'https://api.vitamoment.de/tests';
    function initModalOpeners(container) {
        container.querySelectorAll(`[data-action="open-modal"][aria-controls="${activationModalId}"]`).forEach(btn => {
            btn.addEventListener('click', () => {
                activationForm.dispatchEvent(new CustomEvent('theme:form:setstep', { detail: 1 }));
                // Set focus on input after transition ended
                activationForm.addEventListener('transitionend', () => {
                    const firstInput = activationForm.querySelector('[data-form-step="1"] [data-form-step-autofocus]');
                    if (firstInput)
                        firstInput.focus();
                }, { once: true });
            });
        });
    }
    initModalOpeners(document);
    activationForm.addEventListener('theme:form:step', async (e) => {
        const event = e;
        try {
            const customerId = event.detail.customerCode;
            let testId = event.detail.testCode;
            if (testId.length > 10)
                testId = testId.slice(0, 10);
            const success = await API.verify(testId, customerId);
            if (success) {
                activationForm.dispatchEvent(new CustomEvent('theme:form:continue', { detail: { successAlert: 'default' } }));
                const firstInput = activationForm.querySelector('[data-form-step="2"] [data-form-step-autofocus]');
                if (firstInput)
                    firstInput.focus();
            }
            else {
                activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'invalid' } }));
            }
        }
        catch (err) {
            console.error(err);
            activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'default' } }));
        }
    });
    activationForm.addEventListener('theme:form:submit', async (e) => {
        const event = e;
        try {
            if (event.detail.testCode.length > 10)
                event.detail.testCode = event.detail.testCode.slice(0, 10);
            await API.activate(event.detail);
            fetch(`${location.pathname}?section_id=lab-tests`).then(response => response.text()).then(html => {
                document.querySelector('#shopify-section-lab-tests').outerHTML = html;
                const newSectionElement = document.querySelector('#shopify-section-lab-tests');
                newSectionElement.querySelector('.LabTestsPanel__ActivationSuccessMessage').setAttribute('aria-hidden', 'false');
                newSectionElement.querySelector('[data-action="open-modal"][aria-controls="modal-lab-test-activation"]').innerText = 'Weiteren Test aktivieren';
                initModalOpeners(newSectionElement);
                activationForm.querySelector('input[name="testCode"]').value = '';
                activationForm.closest('.Modal').querySelector('[data-action="close-modal"]').click();
            }).catch(err => {
                console.error('Error reloading test section', err);
            }).finally(() => {
                activationForm.dispatchEvent(new CustomEvent('theme:form:done'));
            });
        }
        catch (err) {
            console.error(err);
            activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'default' } }));
        }
    });
})();
/**
 * Club product slider
 */
(function () {
    const clubTabSwitches = document.querySelectorAll('.AccountSection .tab-switch [data-action="toggle-tab"]'), clubProductSlider = document.querySelector('.AccountProductSlider .Slider');
    if (!clubTabSwitches.length || !clubProductSlider)
        return;
    const clubSlider = new Slider(clubProductSlider);
    clubTabSwitches.forEach((tabSwitch) => {
        tabSwitch.addEventListener('click', () => {
            const target = tabSwitch.getAttribute('aria-controls');
            if (target === 'club-rewards') {
                clubSlider.enable();
            }
            else {
                clubSlider.disable();
            }
        });
    });
})();
export {};
